import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServerConfigService } from '@app/configuration/server-config.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ServerTimeService {
  constructor(
    private http: HttpClient,
    private configService: ServerConfigService,
  ) {}

  getTime(): Observable<Date> {
    return this.http
      .get<{ startTime: Date; currentTime: Date }>(
      `${this.configService.config.apiBaseUrl}/system/time`,
    )
      .pipe(map((result) => result.currentTime));
  }
}
